import ContactSerious from "./ContactSerious"

export default ContactSerious